import axios from '@/axios';

const normalizerBasePath = process.env.VUE_APP_NORMALIZER_ENDPOINT;


export default {
    fetchAll() {
        return axios.get(`${normalizerBasePath}/unlabelled`);
    },
    labelize(unlabelledUuid, uuid, type) {
        return axios.post(`${normalizerBasePath}/unlabelled/${unlabelledUuid}/labelize`, {
            type: type,
            uuid: uuid,
        });
    },
    deleteUnlabelled(unlabelledUuid) {
        return axios.delete(`${normalizerBasePath}/unlabelled/${unlabelledUuid}`);
    },
};
